import { Grid, Typography } from '@mui/material';
import { GroupView } from 'components/TeamOverview/BillingSection/views/BlockManagerDefaultView/GroupView';
import { BlockManagerRow } from 'components/TeamOverview/BillingSection/views/BlockManagerDefaultView/BlockManagerRow';
import { useTeamBlocksBilling } from 'components/TeamOverview/BillingSection/hooks/useTeamBlocksBilling';
import { useCommonStyles } from 'components/TeamOverview/BillingSection/styles';
import { groupBlocksByProject } from 'components/TeamOverview/BillingSection/utilities/utilities';
import Box from '@mui/material/Box';

export const BlockManagerDefaultView = ({ team, filter }) => {
  const { classes } = useCommonStyles();
  const { blocksBillings } = useTeamBlocksBilling(team);

  const groups = groupBlocksByProject(blocksBillings, filter);
  const projects = Array.from(groups.keys());

  return (
    <Grid className={classes.scrollableContainer}>
      <Grid container className={classes.row}>
        <Grid xs={3}>PROJECT/ORDER ID</Grid>
        <Grid xs={1}>BLOCK COUNT</Grid>
        <Grid xs={2}>STATUS</Grid>
        <Grid xs={2}>USER</Grid>
        <Grid xs={2}>DATE FULFILLED</Grid>
        <Grid xs={2}>NEXT BILLING DATE</Grid>
      </Grid>
      {projects.length ? (
        projects.map((project) => (
          <GroupView
            key={project.uuid}
            project={project}
            RowComponent={BlockManagerRow}
            orders={groups.get(project)}
          />
        ))
      ) : (
        <Box className={classes.noDataContainer}>
          <Typography className={classes.noDataLabel}>No Blocks</Typography>
        </Box>
      )}
    </Grid>
  );
};
